import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProductTariffOverride from './product-tariff-override';
import ProductTariffOverrideDetail from './product-tariff-override-detail';
import ProductTariffOverrideUpdate from './product-tariff-override-update';
import ProductTariffOverrideDeleteDialog from './product-tariff-override-delete-dialog';

const ProductTariffOverrideRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProductTariffOverride />} />
    <Route path="new" element={<ProductTariffOverrideUpdate />} />
    <Route path=":id">
      <Route index element={<ProductTariffOverrideDetail />} />
      <Route path="edit" element={<ProductTariffOverrideUpdate />} />
      <Route path="delete" element={<ProductTariffOverrideDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProductTariffOverrideRoutes;
